module.exports = __webpack_public_path__ + "b262c0622809fc905bbacb12992adc81.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/poppins/Poppins-SemiBold.woff2
// module id = 1578
// module chunks = 0